import * as _ from "lodash";
import * as angular from "angular";
import { HouseOccupantService } from "../../../services/house-occupant.service";
import { PermissionCheck } from "../../../shared/permission";
import { DialogUtils } from "../../../helper/dialog.helper";
import { HouseOccupant } from "../../../models/house-occupant.model";

let CanvassHouseOccupantComponent = {
    selector: "vcCanvassHouseOccupant",
    templateUrl:
        "/angular/components/canvass/modals/canvass-house-occupant.component.html",
    bindings: {
        selectedHid: "=",
        selectedHouseoccupant: "=",
    },
    controller: class CanvassHouseOccupantController {
        // * bindings for typescript compiler *
        public selectedHid: any;
        public selectedHouseoccupant: any;
        // ************************************

        private houseoccupant: HouseOccupant;
        private hoid: string | null = null;
        private loading = true;
        private houseoccupants: HouseOccupant[] = [];

        private dialog: DialogUtils;
        private __env: any;

        private permissionProvider: PermissionCheck;
        private houseOccupantResource: HouseOccupantService;

        constructor(
            DialogUtils: DialogUtils,
            HouseOccupantService: HouseOccupantService,
            PermissionCheck: PermissionCheck,
            __env: any
        ) {
            this.dialog = DialogUtils;
            this.__env = __env;

            this.houseOccupantResource = HouseOccupantService;
            this.permissionProvider = PermissionCheck;
        }

        $onInit() {
            this.houseoccupant = this.selectedHouseoccupant;
            this.hoid = this.houseoccupant
                ? _.cloneDeep(this.houseoccupant.hoid)
                : null;

            this.houseOccupantResource
                .house(this.selectedHid)
                .then((response: object) => {
                    const json = response["data"];
                    this.loading = false;

                    if (json.success) {
                        this.houseoccupants = json.data;
                        if (this.selectedHouseoccupant) {
                            angular.forEach(
                                this.houseoccupants,
                                (houseoccupant) => {
                                    if (
                                        houseoccupant.hoid ==
                                        this.selectedHouseoccupant.hoid
                                    ) {
                                        this.houseoccupant = houseoccupant;
                                        this.hoid = _.cloneDeep(
                                            this.houseoccupant.hoid
                                        );
                                    }
                                }
                            );
                        }
                    }
                });
        }

        confirm(hoid: string | null): void {
            this.houseoccupant = null;
            angular.forEach(this.houseoccupants, (houseoccupant) => {
                if (houseoccupant.hoid == hoid) {
                    this.houseoccupant = houseoccupant;
                }
            });
            this.dialog.hide(this.houseoccupant);
        }

        checkAnonymousCanvass(): boolean {
            if (
                this.houseoccupants.length > 0 &&
                !this.permissionProvider.hasPermission("ANON_CANVASSING")
            ) {
                this.houseoccupant = this.houseoccupants[0];
                return true;
            }
            return false;
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("canvass")
    .component(
        CanvassHouseOccupantComponent.selector,
        CanvassHouseOccupantComponent
    );
